import { useEffect, useState } from 'react';

import { useForm } from 'react-hook-form';

import { recoverUpdate } from '../../../services/Users';
import { useAppContext } from '../../../contexts/app';
import { DEFAULT_PASSWORD_POLICY, getClientParametersByToken } from '../../../services/PasswordPolicies';

const useResetPassword = (token) => {
  const { blockScreen, handleAlert } = useAppContext();

  const formMethods = useForm({
    defaultValues: {
      recoveryToken: token,
      newPassword: '',
      repeatNewPassword: '',
    },
  });

  const [passwordPolicies, setPasswordPolicies] = useState(DEFAULT_PASSWORD_POLICY);

  useEffect(() => {
    const fn = async () => {
      blockScreen(true);
      try {
        const policies = await getClientParametersByToken(token);
        setPasswordPolicies({
          ...DEFAULT_PASSWORD_POLICY,
          ...policies,
        });
      } catch (error) {
        handleAlert(error, 'error');
      } finally {
        blockScreen(false);
      }
    };
    fn();
    formMethods.reset();
  }, []);

  const handleOnSubmit = (data) => {
    blockScreen(true);
    Promise.all([recoverUpdate(data)]).then(() => {
      formMethods.reset();
      blockScreen(false);
      handleAlert('Password changed succefully!', 'success');
      setTimeout(() => {
        window.location.href = '/#/';
      }, 1000);
    }).catch((error) => {
      handleAlert(error, 'error');
      blockScreen(false);
    });
  };

  return {
    formMethods,
    passwordPolicies,
    handleOnSubmit,
  };
};

export default useResetPassword;
